import type { HelpFile } from '../../types/help'
import { AutoAssignRulesTestIds } from '../../../testids/AutoAssignRulesTestIds'

export const autoAssignRulesHelp: HelpFile = {
  docPage: '/docs/governance/auto-assign-rules',
  texts: {
    [AutoAssignRulesTestIds.autoAssignRulesPage]:
      'List of auto-assign rules that automatically grant access profiles to identities matching a condition.',
    [AutoAssignRulesTestIds.btnExecutionHistory]:
      'Open the execution history showing each evaluation run, the identities affected, and any errors encountered.',
    [AutoAssignRulesTestIds.colName]: null,
    [AutoAssignRulesTestIds.colOwner]:
      'Party that owns the rule and is responsible for keeping its condition correct.',
    [AutoAssignRulesTestIds.colPriority]:
      'Priority used to break ties when multiple rules grant the same access profile.',
    [AutoAssignRulesTestIds.colType]:
      'Whether the rule grants access profiles directly or a function group bundling several access profiles.',
    [AutoAssignRulesTestIds.colTarget]:
      'What the rule grants when its condition matches — either a count of access profiles or the name of a function group.',
    [AutoAssignRulesTestIds.colRisk]:
      'Risk level of the most sensitive access profile this rule grants.',
    [AutoAssignRulesTestIds.colStatus]:
      'Whether the rule is active, paused, or in draft.',
  },
}
